import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';

import SmartBrowser from '../NavigationContentDrawer/Panels/PrimaryNavigationColumn/SmartBrowser/SmartBrowser';
import { useHamburgerButtonPresenter } from './HamburgerButton/HamburgerButton.presenter';

const TOP = 75;
const BOTTOM_MARGIN = 25;
const RIGHT_MARGIN = 28;

const StyledWrapperView = styled.ScrollView`
  position: absolute;
  right: ${RIGHT_MARGIN}px;
  top: ${TOP}px;
  width: 100%;
  max-width: 380px;
  border-radius: 20px;
  box-shadow: 0 0 25px ${OwnableTheme.colors.modalShadow};
  background-color: white;
`;

const StyledPressable = styled.Pressable`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: ${OwnableTheme.colors.modalShadowDark};
  backdrop-filter: blur(6px);
`;

const SideDrawerRightPanel = () => {
  const { height: windowHeight } = useWindowDimensions();
  const { isOpen } = useHamburgerButtonPresenter();
  const [contentHeight, setContentHeight] = useState(0);

  const height = Math.min(windowHeight - TOP - BOTTOM_MARGIN, contentHeight);
  const width = useWindowDimensions().width - RIGHT_MARGIN * 2;

  return (
    <StyledPressable
      onPress={() => {
        isOpen.set(false);
      }}
    >
      <StyledWrapperView style={{ height, width }}>
        <SmartBrowser onHeight={setContentHeight} />
      </StyledWrapperView>
    </StyledPressable>
  );
};

export default observer(SideDrawerRightPanel);
